import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card'
import { Switch } from './ui/switch'

export interface NotificationPreferenceItem {
  key: string
  name: string
  description: string
  isMandatory: boolean
  isEnabled: boolean
  isSaving?: boolean
}

export interface NotificationPreferencesProps {
  items: ReadonlyArray<NotificationPreferenceItem>
  onChange: (key: string, enabled: boolean) => void
  title?: string
  description?: string
}

/** Einheitliche persönliche Benachrichtigungseinstellungen für Fachmodule. */
export function NotificationPreferences({
  items,
  onChange,
  title = 'E-Mail-Benachrichtigungen',
  description = 'Legen Sie fest, welche optionalen Hinweise Sie erhalten möchten.',
}: NotificationPreferencesProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            Für dieses Modul sind keine Benachrichtigungen eingerichtet.
          </p>
        ) : (
          <ul className="divide-y">
            {items.map((item) => (
              <li
                key={item.key}
                className="flex min-h-16 items-center justify-between gap-4 py-3"
              >
                <div className="min-w-0">
                  <p className="font-medium">{item.name}</p>
                  <p className="text-sm text-muted-foreground">{item.description}</p>
                  {item.isMandatory && (
                    <p className="text-xs text-muted-foreground">Verpflichtend</p>
                  )}
                </div>
                <Switch
                  aria-label={`${item.name} ${item.isEnabled ? 'ausschalten' : 'einschalten'}`}
                  checked={item.isEnabled}
                  disabled={item.isMandatory || item.isSaving}
                  onCheckedChange={(checked) => onChange(item.key, checked)}
                />
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  )
}
